import React, { useState } from "react";

import {
  findBookingFormAlertByName,
  normalizeBookingFormAlertButtons,
  normalizeBookingFormAlertInfo,
} from "shared/lib/bookingFormAlerts";
import { BookingFormRadioMarketplaceProps } from "shared/types";

import Img from "@components/FileServer/Img";
import FormErrorText from "@components/UI/Form/FormErrorText";
import FormattedMessage from "@components/UI/FormattedMessage";

import PriceFormatter from "../Formatters/PriceFormatter";
import BookingFormInfoModal from "./BookingFormInfoModal";

export default function BookingFormRadioMarketplace({
  value,
  onChange,
  options,
  isError,
  alert,
  errorType,
  name,
}: BookingFormRadioMarketplaceProps): React.ReactElement {
  const [showModal, setShowModal] = useState(false);
  const [promptPaidServices, setPromptPaidServices] = useState(false);
  const [activeAlert, setActiveAlert] = useState<any>(null);

  const selectedValue =
    options.length > 0 &&
    !!value &&
    options.find((option) => option.value === value);

  const onChangeHandler = (option) => {
    const matchedAlert = findBookingFormAlertByName(
      alert,
      option?.optionAlertName
    );

    if (matchedAlert && !promptPaidServices) {
      setActiveAlert(matchedAlert);
      setShowModal(true);
    } else {
      setActiveAlert(null);
    }

    onChange(option?.value);
  };

  const onKeyDownHandler = (event, option) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    onChangeHandler(option);
  };

  const customModalButtons = (buttons) => {
    return normalizeBookingFormAlertButtons(buttons).map((button) => {
      return {
        ...button,
        Highlight: button?.Highlight === "true",
        label: button?.$t,
        onClick: () => {
          if (button?.Action === "cancel") {
            setShowModal(false);
            setActiveAlert(null);
          }
          if (button?.Action === "reopen") {
            setShowModal(false);
            setActiveAlert(null);
            setPromptPaidServices(true);
            onChange(null);
          }
        },
      };
    });
  };

  return (
    <>
      <div className="form-marketplace-radio-container" role="radiogroup">
        {options.map((option) => (
          <div
            role="radio"
            className="form-marketplace-row-wrapper"
            key={option.value}
            onClick={() => onChangeHandler(option)}
            onKeyDown={(event) => onKeyDownHandler(event, option)}
            tabIndex={0}
            aria-checked={selectedValue?.value === option?.value}
          >
            {option?.data?.styleClass === "favorite" && option.data.styleClass && (
              <div className={`${option.data.styleClass}-badge`}>
                <FormattedMessage id="Result.favorite" />
              </div>
            )}
            <div className="form-marketplace-radio-input-wrapper">
              <div className="result-box-insurance-one-content">
                <input
                  type="radio"
                  name={name}
                  value={option.value}
                  checked={selectedValue?.value === option?.value}
                  tabIndex={-1}
                  readOnly
                />
                <Img
                  src={`static/images/${
                    selectedValue?.value === option?.value
                      ? "ico-greencheck"
                      : "ico-check-normal"
                  }.svg`}
                  className="result-insurance-circle"
                  alt="green check icon"
                />
              </div>
            </div>
            <div
              className={`form-marketplace-radio-info-wrapper ${
                option?.data?.styleClass || ""
              }`}
            >
              <span className="radio-label">{option?.label}</span>
              <div className="radio-description">
                {option?.data?.description}
              </div>
            </div>
            <label className="radio-price" htmlFor={name}>
              {option?.data?.serviceName.includes("insurance") ? (
                <>
                  <PriceFormatter
                    price={option?.data?.amountPerPassenger}
                    customCurrency={option?.data?.currency}
                    newLine={option?.data?.amountPerPassenger?.length !== 1}
                  />
                  <div>
                    <FormattedMessage id="Form.forPerson" />
                  </div>
                </>
              ) : (
                <PriceFormatter
                  price={option?.data?.price}
                  customCurrency={option?.data?.currency}
                />
              )}
            </label>
          </div>
        ))}

        <BookingFormInfoModal
          show={showModal}
          onClose={() => {
            setShowModal(false);
            setActiveAlert(null);
          }}
          title={activeAlert?.Label?.$t}
          contentId={`marketplace-section-modal-content ${activeAlert?.Name}`}
          content={
            normalizeBookingFormAlertInfo(
              activeAlert?.AdditionalInfo?.Info
            )?.[0]?.$t
          }
          customButtons={customModalButtons(activeAlert?.Buttons?.Button)}
        />

        {isError && (
          <div className="form-text-input-error-radio">
            {/* @ts-ignore */}
            <FormErrorText error={errorType} />
          </div>
        )}
      </div>
    </>
  );
}
